
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage";
import { GoogleAuthProvider } from "firebase/auth"
import { collection, getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAUUfzCcZ12uzZdp9bZS059lDzFfG4-Vdc",
  authDomain: "lumera3d-929cb.firebaseapp.com",
  projectId: "lumera3d-929cb",
  storageBucket: "lumera3d-929cb.firebasestorage.app",
  messagingSenderId: "38432772354",
  appId: "1:38432772354:web:33b17eb58fa6562849f21b"
};

const app = initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(app);

export const db = getFirestore(app)

export const storage = getStorage(app)

export const collectionRef = collection(db, "clientes")
